<template>
  <div
    class="matrix-cell"
    :class="{
      'matrix-cell--first-level': isFirstLevel,
      'matrix-cell--focused-column': isFocusedColumn,
      'matrix-cell--focused-cell': isFocusedCell,
    }"
    :title="title"
    @click="$emit('select')"
  >
    <!-- Fully controlled by `state`: the native toggle is prevented, otherwise
         b-form-checkbox keeps its own checked flag when `checked` stays false. -->
    <b-form-checkbox
      class="matrix-cell__checkbox"
      :class="{ 'matrix-cell__checkbox--partial': isIndeterminate }"
      :checked="state === 'allow'"
      :indeterminate="isIndeterminate"
      @click.native.prevent="$emit('toggle')"
    />
    <i v-if="hint" class="fa fa-exclamation-circle matrix-cell__hint" :title="hint" />
  </div>
</template>

<script>
const INDETERMINATE_STATES = ['partial'];

export default {
  name: 'MatrixCell',
  props: {
    state: { type: String, required: true },
    title: { type: String, required: true },
    isFirstLevel: { type: Boolean, default: false },
    isFocusedColumn: { type: Boolean, default: false },
    isFocusedCell: { type: Boolean, default: false },
    hint: { type: String, default: '' },
  },
  computed: {
    /** Partial: some units below the node have the level (dash, faded). */
    isIndeterminate() {
      return INDETERMINATE_STATES.includes(this.state);
    },
  },
};
</script>

<style lang="scss" scoped>
.matrix-cell {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 72px;
  padding: 4px 0;
  cursor: pointer;

  &--first-level {
    border-left: 1px solid $gray-200;
  }

  &--focused-column {
    background-color: rgba($gray-600, 0.04);
  }

  &--focused-cell {
    box-shadow: inset 0 0 0 1px $gray-600;
  }
}

.matrix-cell__checkbox {
  margin-right: -8px;

  &--partial {
    opacity: 0.5;
  }
}

.matrix-cell__hint {
  margin-left: 4px;
  color: $warning;
  font-size: 0.75rem;
}
</style>
